import { t } from '../../../locale/texts';

export const tripTypesOptions = [
    { value: 'roundtrip', label: t('flight.tripType.roundtrip') },
    { value: 'oneway', label: t('flight.tripType.oneway') },
    { value: 'openjaw', label: t('flight.tripType.openjaw') },
];

export const cabinTypesOptions = [
    { value: 'economy', label: t('flight.cabinType.economy') },
    { value: 'premium', label: t('flight.cabinType.premium') },
    { value: 'business', label: t('flight.cabinType.business') },
    { value: 'first', label: t('flight.cabinType.first') },
    { value: 'all', label: t('flight.cabinType.all') },
];
